<div class="bulk-pricing-models">
  <div class="header">
    <div>
      <h2>Bulk Pricing</h2>
      <p class="header-hint">
        Products carrying one of these tags are sold at a tiered discount, so the Google feed advertises
        the price a buyer actually pays. A tier only applies when a single unit already reaches its order amount.
      </p>
    </div>
    <button mat-raised-button color="primary" (click)="createModel()">
      <mat-icon>add</mat-icon>
      Add Pricing Model
    </button>
  </div>

  <div class="content" [class.loading]="loading">
    <mat-spinner *ngIf="loading" diameter="50"></mat-spinner>

    <div *ngIf="!loading && models.length === 0" class="no-models">
      <mat-icon>sell</mat-icon>
      <h3>No bulk pricing models</h3>
      <p>Add one to discount every product carrying a given tag in the Google feed.</p>
      <button mat-raised-button color="primary" (click)="createModel()">
        Add Pricing Model
      </button>
    </div>

    <div *ngIf="!loading && models.length > 0" class="models-grid">
      <mat-card *ngFor="let model of models" class="model-card" [class.inactive]="!model.active">
        <mat-card-header>
          <mat-card-title>{{ model.label || model.tag }}</mat-card-title>
          <mat-card-subtitle>
            tag: {{ model.tag }} &middot; priority {{ model.priority }} &middot; {{ model.stores.join(', ') }}
            <span *ngIf="!model.active" class="inactive-flag">&middot; inactive</span>
          </mat-card-subtitle>
          <div class="card-actions">
            <button mat-icon-button [matMenuTriggerFor]="menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="editModel(model)">
                <mat-icon>edit</mat-icon>
                <span>Edit</span>
              </button>
              <button mat-menu-item (click)="toggleModel(model)">
                <mat-icon>{{ model.active ? 'pause' : 'play_arrow' }}</mat-icon>
                <span>{{ model.active ? 'Deactivate' : 'Activate' }}</span>
              </button>
              <mat-divider></mat-divider>
              <button mat-menu-item (click)="deleteModel(model)" class="delete-option">
                <mat-icon>delete</mat-icon>
                <span>Delete</span>
              </button>
            </mat-menu>
          </div>
        </mat-card-header>

        <mat-card-content>
          <table class="tier-table">
            <thead>
              <tr>
                <th>Order Amount</th>
                <th>Discount</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let tier of model.tiers">
                <td>{{ tierRange(tier) }}</td>
                <td>{{ tier.discount_percent }}%</td>
              </tr>
              <tr *ngIf="!model.tiers.length">
                <td colspan="2" class="no-tiers">No tiers — nothing is discounted</td>
              </tr>
            </tbody>
          </table>

          <div class="model-note" *ngIf="model.note">{{ model.note }}</div>

          <div class="model-meta" *ngIf="model.updated_at">
            Updated {{ model.updated_at | date:'short' }}
            <span *ngIf="model.updated_by?.name">by {{ model.updated_by?.name }}</span>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
